import { render, staticRenderFns } from "./ManagePublicMemberships.vue?vue&type=template&id=523b19cd&scoped=true"
import script from "./ManagePublicMemberships.vue?vue&type=script&lang=js"
export * from "./ManagePublicMemberships.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523b19cd",
  null
  
)

export default component.exports